import React, { Component } from 'react'

import Radio from './Radio'

class RadioGroup extends Component {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate)
        }

        this.value = props.defaultChecked

        this.state = {
            isInValid: false,
        }
    }

    componentWillUnmount() {
        const { unregister, name } = this.props

        if (typeof unregister === 'function') {
            unregister(name)
        }
    }

    validate = (obj, setState = false) => {
        const isValid = true
        if (setState) {
            this.setState({
                isInValid: !isValid,
            })
        }

        return isValid
    }

    validate = () => true

    onChange = ({ name, value }) => {
        const { onBlur } = this.props

        this.value = value

        this.setState({
            isInValid: !this.validate({ checked: value, name }),
        })

        if (typeof onBlur === 'function') {
            onBlur({ value: this.value, name: this.props.name })
        }
    }

    render() {
        const {
            options, emptyError, defaultChecked, refreshOnRender, name,
        } = this.props
        const { isInValid } = this.state
        if (refreshOnRender) {
            this.value = defaultChecked
        }

        return (
            <div
                className={`form-radioGroup ${isInValid ? 'validation-error' : ''}`}
                style={{
                    flex: 1,
                }}
            >
                {options.map(({ value, label }) => (
                    <div style={{ display: 'flex' }}>
                        <Radio
                            name={name}
                            id={value}
                            label={label}
                            onBlur={this.onChange}
                            defaultChecked={this.value === value}
                            checked={this.value === value}
                            className="exploriNativeRadio"
                            key={value}
                        />
                    </div>
                ))}
                {isInValid && (
                    <div
                        className="errorMsg"
                        style={{
                            color: '#df107f',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {emptyError}
                        {' '}
                        <i className="fal fa-exclamation-circle fa-fw" />
                    </div>
                )}
            </div>
        )
    }
}

export default RadioGroup
